import mapInboxRuleToInboxRuleInformation from './mapInboxRuleToInboxRuleInformation';
export default function canRunRule(inboxRule) {
    var ruleInfo = mapInboxRuleToInboxRuleInformation(inboxRule);
    // Rule must have a single sender and only a single condition,
    // since only bulk actions supported now is sweep
    if (!ruleInfo.NumFrom || ruleInfo.NumConditionalClauses > 1) {
        return false;
    }
    // Exception clauses not supported
    if (ruleInfo.NumExceptionClauses > 0) {
        return false;
    }
    // Action must be a 'move to folder' type
    if (ruleInfo.NumActionClauses == 1 && (ruleInfo.MoveToFolder || ruleInfo.DeleteMessage)) {
        return true;
    }
    return false;
}
//# sourceMappingURL=canRunRule.js.map